/**
 * @generated SignedSource<<7d91b46cd5c1caf3a612fcfb7574c929>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericArticleSpeechInlineWidgetGenericArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"buttonArticleSpeechInlineWidgetGenericButtonArticle" | "hooksShowGenericInlineWidgetByArticleArticle" | "toolTipArticleSpeechWidgetToolTipArticle">;
  readonly " $fragmentType": "genericArticleSpeechInlineWidgetGenericArticle";
};
export type genericArticleSpeechInlineWidgetGenericArticle$key = {
  readonly " $data"?: genericArticleSpeechInlineWidgetGenericArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleSpeechInlineWidgetGenericArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericArticleSpeechInlineWidgetGenericArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "buttonArticleSpeechInlineWidgetGenericButtonArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksShowGenericInlineWidgetByArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "toolTipArticleSpeechWidgetToolTipArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "9af0cda85b6338ee233febcac8e556c7";

export default node;
